/*
 * File: index.js
 * File Created: Tuesday, 26th May 2020 3:46:25 pm
 * Author: yancr (yancr@lenovocloud.com)
 * -----
 * Last Modified: Wednesday, 27th May 2020 1:50:16 pm
 * Modified By: yancr (yancr@lenovocloud.com>)
 */
import store from 'store'
import Cookie from 'js-cookie'
import LdTool from 'js/lib/ldtool'
import _$ from 'js/api/getdata.js'
import { isLinux, isMacOs } from 'js/util/util'
function runCallback(fn, ...arg) {
  if(typeof fn === 'function'){
    fn(arg)
  }
}

function setServerType(callback) {
  // 表示ldtool在公有网盘下使用
  let isExe = false
  const timer = setTimeout(() => {
    isExe = true
    runCallback(callback)
  }, 2000)
  // 表示ldtool在公有网盘下使用
  window.LDTool.setOption(
    {
      server_type: 1,
    },
    res => {
      clearTimeout(timer)
      if (isExe) return
      runCallback(callback, res)
    },
  )
}

/** *
 * 初始化LdTool
 * @param {function} obj.notSupportCallback notSupportCallback 回调，不支持sdk（不支持websocket和ActiveXObject）
 * @param {function} obj.allErrorCallback allErrorCallback 回调，在初始化失败的时候会执行
 * @param {function} obj.editCallback editCallback 回调，本地打开失败的时候报错
 * @param {function} obj.connectErrorCatch connectErrorCatch 回调，创建连接整个过程的try catch的错误处理函数
 * @param {function} obj.sessionOccupied sessionOccupied 回调  session被占用的
 * @param {function} obj.noUseableTool noUseableTool 回调 没有可用的工具的回调
 * @param {function} callback 初始化成功的回调
 * * */
export function initLdTool(
  {
    notSupportCallback = () => {},
    allErrorCallback = () => {},
    editCallback = () => {},
    sessionOccupied = () => {},
    noUseableTool = () => {},
    connectErrorCatch = () => {},
    successCallback = () => {},
    needLogin = false,
  },
  callback,
) {
  window.LDTool = new LdTool({
    notSupportCallback,
    allErrorCallback,
    editCallback,
    sessionOccupied,
    noUseableTool,
    connectErrorCatch,
    successCallback,
  })

  if (needLogin) {
    // 用户id
    let uid = store.getters.uId
    // account_id客户端需要字符串类型
    let account_id = `${store.getters.accountId}`
    let sid = Cookie.get('X-LENOVO-SESS-ID')

    window.LDTool.init(uid, sid, {
      initCallback: () => {
        setServerType(callback)
      },
      paramsJson: JSON.stringify({ account_id }),
    })
  } else {
    setServerType(callback)
  }
}

/**
 * 给webtool设置语言
 * @param {string} language 语言 zh_cn,zh_tw,en三选一
 * @param {function} callback 回调，设置成功失败都会执行
 * * */
export function setLanguage(language, callback) {
  window.LDTool.setOption(
    {
      language,
    },
    res => {
      runCallback(callback, res)
    },
  )
}

/**
 * 使用 webtool 下载文件
 * @param {Object} params
 * @param {Object|Array|any} params.metadata 要下载的meta信息
 * @param {boolean} params.isNeedPath 是否需要path 在metadata不是数组的时候生效
 * @param {boolean} params.isShowPath  为是否显示本地下载位置选择框，false则使用默认下载地址 仅仅在metadata是数组的时候生效
 * @param {boolean} params.isShowTrans   为是否显示传输列表 仅仅在metadata是数组的时候生效
 * @param {function} callback 回调函数
 * * */
export function downloadCore(
  { metadata, isNeedPath = false, isShowPath = false, isShowTrans = false },
  callback,
) {
  window.LDTool.downloadCore(
    {
      metadata,
      isNeedPath,
      isShowPath,
      isShowTrans,
    },
    res => {
      runCallback(callback, res)
    },
  )
}

/**
 * 外链下载
 * @param {object} obj
 * @param {object} obj.metadata 文件的meta信息
 */
export function deliveryDownload({ metadata }, callback) {
  window.LDTool.deliveryDownload(metadata, res => {
    runCallback(callback, res)
  })
}

/**
 * 检查webtool状态，是否在运行，以及版本信息
 * @param {function} suc
 * @param {function} fail
 */
export function runStatus(suc = () => {}, fail = () => {}) {
  window.LDTool.runStatus(suc, fail)
}

/**
 * 下载webtool
 */
export function downloadWebTool() {
  let url = ''
      if(isLinux()){
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.deb'
      } else if(isMacOs()) {
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.dmg'
      } else{
        url = '/client/ldwebtool/bin/zBox_WebTool_installer.exe'
      }
      window.open(url, '_self')
}
